import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var RightIndent01 = function RightIndent01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M21 4H3m18 16H3m9-10.75H3m9 5.5H3m16.72-6.29-3.8667 2.9c-.2895.2171-.4342.3257-.486.4588a.5.5 0 0 0 0 .3624c.0518.1331.1965.2417.486.4588l3.8667 2.9c.412.309.618.4635.7904.4599a.5.5 0 0 0 .3833-.1917C21 15.6725 21 15.415 21 14.9V9.1c0-.515 0-.7725-.1063-.9082A.5.5 0 0 0 20.5104 8c-.1724-.0036-.3784.151-.7904.4599"
    })
  }));
};
export default RightIndent01;